import { useState } from "react";
import  "./MouthfeelLevel.css";


const MouthfeelLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.mouthfeellevel===0?0:data.mouthfeellevel);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="MouthfeelLevelCard" name="mouthfeellevel" onChange={onChangeValue}>
    <div class="MouthfeelLevel-rating-container">

      <div class="MouthfeelLevel-rating">
        <form class="MouthfeelLevel-rating-form-1" >

          <label for={`ML1F-${count}`}>
            <input type="radio"  name="mouthfeellevel" class="MouthfeelLevel1" id={`ML1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>

          <label for={`ML2F-${count}`}>
              <input type="radio" name="mouthfeellevel" class="MouthfeelLevel2" id={`ML2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`ML3F-${count}`}>
              <input type="radio" name="mouthfeellevel" class="MouthfeelLevel3" id={`ML3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`ML4F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel4" id={`ML4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>

            </label>

          <label for={`ML5F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel5" id={`ML5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`ML6F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel6" id={`ML6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML7F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel7" id={`ML7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML8F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel8" id={`ML8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML9F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel9" id={`ML9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>

             </label>

             <label for={`ML10F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel10" id={`ML10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML11F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel11" id={`ML11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML12F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel12" id={`ML12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`ML13F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel13" id={`ML13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>

                <p>9</p>
             </label>

             <label for={`ML14F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel14" id={`ML14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML15F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel15" id={`ML15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML16F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel16" id={`ML16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`ML17F-${count}`}>
             <input type="radio" name="mouthfeellevel" class="MouthfeelLevel17" id={`ML17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>


    );
}

export default MouthfeelLevel;